import styled, { css } from "styled-components";

const Wrapper = styled.div<{ reverse: boolean; maxImgHeight?: string }>`
  width: 100%;
  max-width: 1000px;
  display: flex;
  gap: 10%;
  align-items: center;

  ${(props) =>
    props.reverse &&
    css`
      flex-direction: row-reverse;
    `}

  ${(props) => props.theme.breakpoints.M} {
    gap: 5%;
    font-size: 0.9em;
  }
  ${(props) => props.theme.breakpoints.S} {
    flex-direction: column;
  }
`;

const Col = styled.div<{ reverse: boolean }>`
  flex: 0.8;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  text-align: right;
  gap: 20px;
  opacity: 0.6;
  font-style: italic;

  ${(props) =>
    props.reverse &&
    css`
      text-align: left;
      align-items: flex-start;
    `}

  ${(props) => props.theme.breakpoints.M} {
    gap: 15px;
  }
  ${(props) => props.theme.breakpoints.S} {
    margin-top: 10%;
    align-items: center;
  }
`;

const ImgWrapper = styled.div<{ maxWidth?: string; maxHeight?: string }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${(props) => props.maxWidth && `width: ${props.maxWidth};`}
  ${(props) => props.maxHeight && `height: ${props.maxHeight};`}
  overflow: hidden;

  img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;

    ${(props) => props.theme.breakpoints.M} {
      max-width: 80%;
    }
    ${(props) => props.theme.breakpoints.S} {
      max-width: 300px;
      margin: auto;
      margin-top: 20px;
    }
  }
`;

const ReplicaStats = (props: {
  labels: any[];
  img: any;
  reverse?: boolean;
  maxImgWidth?: string;
  maxImgHeight?: string;
}) => {
  return (
    <Wrapper reverse={props.reverse}>
      <Col reverse={props.reverse}>
        {props.labels.map((label, i) => (
          <div key={i}>{label}</div>
        ))}
      </Col>
      <ImgWrapper maxWidth={props.maxImgWidth} maxHeight={props.maxImgHeight}>
        <img src={props.img} alt="stack" />
      </ImgWrapper>
    </Wrapper>
  );
};

export default ReplicaStats;
